/**
 * @generated SignedSource<<564d3e9a80ca63d5437c34441209991c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AccountCreateSelectEmployeeCreateEmployeeMutation$variables = {
  name: string;
  storeId?: string | null;
};
export type AccountCreateSelectEmployeeCreateEmployeeMutation$data = {
  readonly store: {
    readonly employeeCreate: {
      readonly employee: {
        readonly id: string;
      };
    } | null;
  };
};
export type AccountCreateSelectEmployeeCreateEmployeeMutation = {
  response: AccountCreateSelectEmployeeCreateEmployeeMutation$data;
  variables: AccountCreateSelectEmployeeCreateEmployeeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storeId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "storeId"
      }
    ],
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "name"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "EmployeeCreatePayload",
        "kind": "LinkedField",
        "name": "employeeCreate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Employee",
            "kind": "LinkedField",
            "name": "employee",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountCreateSelectEmployeeCreateEmployeeMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AccountCreateSelectEmployeeCreateEmployeeMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "562faf4330cd982589d3497efedc057a",
    "id": null,
    "metadata": {},
    "name": "AccountCreateSelectEmployeeCreateEmployeeMutation",
    "operationKind": "mutation",
    "text": "mutation AccountCreateSelectEmployeeCreateEmployeeMutation(\n  $storeId: ID\n  $name: String!\n) {\n  store(id: $storeId) {\n    employeeCreate(input: {name: $name}) {\n      employee {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "87a526af38d6fd7673701556f5a54d59";

export default node;
